/*!Copyright 2010 karmadata, Inc. **/
/**kd.api.data requires these libraries to be loaded first
* jQuery
* Underscore.js
* moment.js
*/

var _ = {}
_.each = require('lodash.foreach')
_.indexOf = require('lodash.indexof')
_.flattenDeep = require('lodash.flattendeep')
var moment = require('moment')


var FilterItem = (function () {
    return function (entityTypeIn, propertyNameIn, filterDataTypeIn, filterOperatorIn, filterValuesIn) {
        /** Private Variables */
        /**
        * The id is a string in the format "KdEntity.PropertyName,
        * e.g., "Person.Name", "KdRxNorm.DateApproved"
        */
        var id = entityTypeIn + "." + propertyNameIn;
        /** The Kd EntityType property that we are filtering on
        * Examples: KdCity, KdPhysician, KdPharmacy
        */
        var entityType = entityTypeIn;
        /** A property or the KdEntity that we are filtering on
        * Examples: BirthDate, FirstName
        */
        var propertyName = propertyNameIn;
        /**
        * Valid DataType values are: String|Date|Number|Boolean|Moment|KdLocation or any data type that starts with Kd like KdCity
        * A Date is "just a day", so midnight on the Date selected, think "YYYY-MM-DD" where the hour, tz, etc do not matter.
        * A Date is good for most queries that look like this "where foo >= barDate" as most people want the transactions for the entire day barDate.
        * We truncate Date filters on server so if you pass in the hours, minutes, seconds, miliseconds and tz...they will be ignored.
        * A Moment requires the use of moment.js and is a full DateTime with tz offset, good for fine grained time based queries (looking for that log entry or appointment between 13:25 and 13:27)
        * A Number is always treated as a decimal, but setting values to 1,2,3 is fine, normal and will work as expected.  As will 1.2345, 2.6789, 3.101112
         * * A Location is a geocode based search, either on Distance (lat, lng, unit, distance - so a radius) or BoundingBox
         *  A KdEntity is a special KarmaData data type in the format {KdId, KdLabel, EntityType}.
        * The KdId is used in the query, the KdLabel is used in the UI to show user what they are filtering on. The EntityType is one of the KdEntityTypes such as KdCity, KdPhysician, etc.
        */
        var dataType = filterDataTypeIn;

        /**Valid filterLogic are And, Or, AndNot, OrNot
         * filterOperators control how filters are applied.  The default is And.  You can change with setFilterLogic()
         */
        var filterLogic = 'And';

        /** Valid filterOperator values for every DataType are:  Eq|NotEq|All|Gt|Gte|Lt|Lte|All|Between|Null|NotNull.
        * Valid filterOperator values for only DataType KdEntity and String are:  Contains|NotContains.
        *  - If Eq|NotEq|All all items in array are considered.
        *  - If Between only first two in array are considered
        *  - If Gt|Gte|Lt|Lte only the first item in the array is considered
        *  - If Contains|NotContains all items in array are considered, but only valid for KdEntity and String
        (for string if and only if KD has set up a special search index like a Google search with themes, fuzzy matching logic, etc)
        */
        var filterOperator;

        /** filterValues are an array of filterValues.
        * The filterValues property of the filterItem object are all arrays of the Filter DataType, except booleanValues which has a single value
        */

        var filterValues = [];

        /** Private Functions */
        var errorCheckArray = function (arrayIn) {
            if (!(typeof (arrayIn) === "object" && arrayIn.length && arrayIn.length > 0)) {
                throw "The value is not a valid array";
            }
        };


        var errorCheckFilterValueValues = function (arrayIn) {
            //errorCheckArray(arrayIn);

            _.each(arrayIn, function (value, index) {
                if (propertyName !== '*') {
                    if (dataType === "String" && typeof(value) !== "string") {
                        throw "The value " + value + " is not a valid String";
                    }
                    if (dataType === "Number" && typeof (value) !== "number") {
                        throw "The value " + value + " is not a valid Number";
                    }
                    if (dataType === "Date" && !moment(value).isValid()) {
                        throw "The value " + value + " is not a valid Date";
                    }
                    if (dataType === "Moment" && !moment.isMoment(value)) {
                        throw "The value " + value + " is not a valid Moment";
                    }
                    if ((dataType === "KdEntity"
                            || dataType.substring(0, 2) === "Kd"

                        )
                        &&
                        !(typeof (value) === "object" && value.KdId && value.KdLabel)) {
                        throw "The value " + value + " is not a valid KdEntity";
                    }
                }



            });


        };

        var errorCheckFilterValueOperator = function (comparisonToCheck) {
            if (_.indexOf(["Eq", "NotEq", "All", "Gt", "Gte", "Lt", "Lte", "Between", "Contains", "NotContains","Like","NotLike","Null","NotNull"], comparisonToCheck) === -1) {
                throw comparisonToCheck + " is not a valid Operator.  Valid Operator are Eq|NotEq|Gt|Gte|Lt|Lte|Contains|NotContains|Between";
            }
            if (_.indexOf(["Contains", "NotContains"], comparisonToCheck) !== -1 && dataType !== "String") {
                throw comparisonToCheck + " is not a valid Operator for DataType " + dataType;
            }
            if (dataType === "Boolean" && comparisonToCheck !== "Eq") {
                throw comparisonToCheck + " is not a valid Operator for DataType " + dataType +
                "The only valid Operator for a Boolean is Eq";
            }
        };

        var errorCheckFilterValuesArray = function (arrayIn) {

            errorCheckArray(arrayIn);

            if (filterOperator === "Null" || filterOperator === "NotNull")
                return true;//no values required for Null or NotNull operator
            else
                errorCheckFilterValueValues(arrayIn);

            // $.each(arrayIn, function (index, arrayValue) {
            //
            // });


        };

        var errorCheckFilterLogic = function (filterLogicToCheck) {
            if (_.indexOf(["And", "Or", "AndNot", "OrNot"], filterLogicToCheck) === -1) {
                throw filterLogicToCheck + " is not a valid Filter Logic.  Valid Logical Operators are And|Or|AndNot|OrNot";
            }
        };

        var errorCheckDataType = function (dataTypeToCheck) {

            if (propertyName !== '*') {

                if (_.indexOf(["String", "Date", "Moment", "Number", "Boolean", "KdEntity", "Geography", "Location"], dataTypeToCheck) === -1) {
                    if (dataTypeToCheck.substring(0, 2) === "Kd") {
                        var todo = null;
                    } else {
                        console.warn(dataTypeToCheck + " is not a valid DataType.  Valid DataTypes are String|Date|Moment|Number|Boolean|Geography|Location or any entity that starts with Kd");
                    }
                }
                ;
            }
        };

        var errorCheckInitState = function () {
            if (!id) {
                throw "The Filter does not have an Id";
            }

            if (!dataType && propertyName!=='*') {
                throw "The Filter with Id: " + id + "  does not have a DataType";
            }
            errorCheckDataType(dataType);
        };

        var setSelected = function (selectedValues, selectedOperator) {

            errorCheckFilterValuesArray(selectedValues);
            filterValues = selectedValues;

            if (selectedOperator){

                errorCheckFilterValueOperator(selectedOperator);
                setOperator(selectedOperator);

            }

        };

        var setOperator = function (opIn) {
            errorCheckFilterValueOperator(opIn);
            filterOperator = opIn;

        };

        var setDefaultOperator = function () {
            /**Default to Eq for all types*/
            filterOperator = "Eq";
                return filterOperator;
        };


        var init = function () {
            // entityTypeIn, propertyNameIn, filterDataTypeIn, filterOperatorIn, filterValuesIn
            if (filterOperatorIn) {
                setOperator(filterOperatorIn);
            }
            else setDefaultOperator();

            if (filterValuesIn) {
                errorCheckFilterValueValues(filterValuesIn);
                filterValues = filterValuesIn;
            }

            errorCheckInitState();

        };

        /** Public Variables */


        //Privileged functions, can access both public and private
        //We need functions here to do error checking and handling
        this.getDataType = function () {
            return dataType;
        };
        this.setDataType = function (filterDataType) {
            if (!filterDataType) {
                throw "A valid Filter DataType is required";
            }
            else {
                errorCheckDataType(filterDataType);
                dataType = filterDataType;
                return dataType;
            }
        };
        this.setFilterLogic = function (filterLogicIn) {
            if (!filterLogicIn) {
                throw "A valid Filter Logic condition is required";
            }
            else {
                errorCheckFilterLogic(filterLogicIn);
                filterLogic = filterLogicIn;
                return filterLogic;
            }
        };
        this.getEntityType = function () {
            return entityType;
        };
        this.setEntityType = function (filterEntityType) {
            if (!filterEntityType) {
                throw "A valid Filter EntityType is required";
            }
            else {
                entityType = filterEntityType;
                return entityType;
            }
        };
        this.getPropertyName = function () {
            return propertyName;
        };
        this.setPropertyName = function (filterPropertyName) {
            if (!filterPropertyName) {
                throw "A valid Filter PropertyName is required";
            }
            else {
                propertyName = filterPropertyName;
                return propertyName;
            }
        };

        this.getOperator = function() {
            return filterOperator;
        }

        this.setOperator = function(opIn) {
            return setOperator(opIn);
        }

        this.setValues = function (valuesIn) {

            if (typeof valuesIn === "undefined") {
                throw "setValues requires an array of values";
            } else {

                setSelected(valuesIn);
                return valuesIn;
            }

        };

        this.addSelected = function (valuesIn) {
            errorCheckFilterValuesArray(valuesIn);
            filterValues.push(valuesIn);
            filterValues = _.flattenDeep(filterValues);
            return filterValues;

        };

        this.getSelected = function () {
            return filterValues;

        };


        this.setSelected = function (selectedValues, selectedOperator) {
            if (typeof selectedValues === "undefined") {
                throw "setSelected requires a parameter of selectedValues";
            } else {
                setSelected(selectedValues, selectedOperator);
                return selectedValues;
            }

        };
        this.clearSelected = function () {
            filterValues = [];
            return filterValues;
        };

        /** Returns a struct that can be passed to the kd API as a filter (part of a FilterList)*/
        this.getFilterItemValue = function () {
            var filter = {};
//            filter.Id = id;
            filter.EntityType = entityType;
            filter.PropertyName = propertyName;
            filter.DataType = dataType;
            filter.Logic = filterLogic;
            filter.Operator = filterOperator;
            if(dataType === "Date") {
                filter.Values = [];
                _.each(filterValues, function (value, index) {
                    var valueToAdd = moment(value).format("YYYY-MM-DD");
                    filter.Values.push(valueToAdd);
                });

            } else{
                filter.Values = filterValues;
            }


            /**
            * Error handling
            */
            errorCheckInitState();

            return filter;
        };

        /** Init functions*/

        init();

    };
})();

var Filter = (function () {
    return function () {
        //Private Variables
        /*kd.api.data.Filter is a Group of filters
        * Each FilterGroup is assigned a number and an operator
        * Filters in each group are applied to the request query as a group**/
        var filterList = [];
        /*valid filterGroupLogic are And, AndNot, Or, OrNot**/
        var filterGroupLogic = 'And';
        var filterGroupJoinEntity;

        //Private Functions
        var getFilterListValues = function () {
            var filters = [];
            _.each(filterList, function (filter, index) {
                var selectedValue = filter.getFilterItemValue();

                if (selectedValue.Values && selectedValue.Values.length > 0) {
                    filters.push(selectedValue);
                } else if(_.indexOf(["Null","NotNull"], selectedValue.Operator) !== -1) {
                    filters.push(selectedValue);
                } else if(selectedValue.PropertyName === '*') {
                    filters.push(selectedValue);
                }


            });
            return filters;
        }
        var removeFromList = function (filterToRemove) {

            _.each(filterList, function (filter, index) {
                if (filterToRemove === filter) {
                    filterList.splice(index, 1); // at position index remove one item
                }

            });
            return filterList;
        }
        var rejectFilter = function (filterIn) {
            return !filterIn; //for now just return true or false if filter is null
        }

        var setFilterGroupLogic = function (groupLogicIn) {
            if (_.indexOf(["And", "Or", "AndNot", "OrNot"], groupLogicIn) === -1) {
                throw groupLogicIn + " is not a valid Filter Group Logic.  Valid Logical Operators are And|Or|AndNot|OrNot";
            }

            else {
                filterGroupLogic = groupLogicIn;
                return filterGroupLogic;
            }
        };

        var setFilterGroupJoinEntity = function (joinEntityIn) {
                filterGroupJoinEntity = joinEntityIn;
                return filterGroupJoinEntity;
        };

        //Public Variables
        //None for this closure

        //Privileged functions, can access both public and private
        //We need functions here to do protected get and set
        //and to do error checking and handling
        this.addFilterItem = function (filterIn) {
            if (rejectFilter(filterIn)) return "A valid KdFilter Object is required";
            else {
                filterList.push(filterIn);
                return filterList;
            }
        };
        this.removeFilterItem = function (filterIn) {
            if (rejectFilter(filterIn)) return "A valid KdFilter Object is required";
            else {
                removeFromList(filterIn);
                return filterList;
            }
        };

        this.getFilterGroupLogic = function () {
            return filterGroupLogic;
        };

        this.setFilterGroupLogic = function (groupLogicIn) {

            setFilterGroupLogic(groupLogicIn);
            return filterGroupLogic;
        };

        this.getFilterGroupJoinEntity = function () {
            if(!filterGroupJoinEntity){
                throw "There is no JoinEntity set, call setFilterGroupJoinEntity() first to join the FilterGroup to the RequestItem"
            }
            return filterGroupJoinEntity;
        };

        this.setFilterGroupJoinEntity = function (groupJoinEntityIn) {

            setFilterGroupJoinEntity(groupJoinEntityIn);
            return filterGroupJoinEntity;
        };

        this.getFilterModel = function () {
                return filterList;
        };
        this.getFilterValue = function () {
            var filterListStruct = getFilterListValues();
            // filterListStruct.KdFilterGroup = filterGroup;
            // filterListStruct.KdFilterGroupLogic = filterGroupLogic;

            return filterListStruct;
        };
        this.clearFilter = function () {
            _.each(filterList, function (filter) {
                filter.clearSelected();
            });
        };

    };
})();


exports.Filter = Filter
exports.FilterItem = FilterItem



//////////////////
// WEBPACK FOOTER
// ./~/karmadata/kd.api.data/kd.api.data.Filter.js
// module id = 198
// module chunks = 0